import { axios } from '@/utils/request'
import store from '@/store'
import { getAppConfig, getPlatformConfig } from '@/AppConfig'
import dbManager from '@/utils/indexeDb'
import Vue from 'vue'
import { ACCESS_TOKEN, SET_CITY_FLAG } from '@/store/mutation-types'

const config = {
  state: {
    platformConfig: {},
    appConfig: {},
    init: false,
    menuList: [],
    isRecharge: false,
    serverDataInfo: {},
    globeCityList: [],
    showPayContract: false,
    showChangLian: false, // 畅联直连
    showTuNiu: false // 途牛直连
  },

  mutations: {
    //初始化标记
    SET_INIT_CONFIG: (state, init) => {
      state.init = init
    },
    //设置项目信息
    SET_PROJECT_INFO: (state, config) => {
      state.platformConfig = config
    },
    SET_APP_CONFIG: (state, config) => {
      state.appConfig = config
    },
    SET_MENU_HEAD_CONFIG: (state, config) => {
      state.menuList = config
      console.log(state.menuList)
    },
    SET_RECHARGE: (state, config) => {
      state.isRecharge = config
    },
    SET_SERVER_DATA: (state, config) => {
      state.serverDataInfo = config
    },
    SET_GLOBE_ALL_CITU: (state, config) => {
      state.globeCityList = config
    },
    UPDATE_PAY_CONTRACT: (state, config) => {
      state.showPayContract = config
    },
    SET_CHANG_LIAN_CONFIG: (state, config) => {
      state.showChangLian = config
    },
    SET_TU_NIU_CONFIG: (state, config) => {
      state.showTuNiu = config
    }
  },

  actions: {
    InitConfig() {
      return new Promise((resolve, reject) => {
        axios({
          baseURL: '',
          url: '/ServiceConfig.json?time=' + Date.now(),
          method: 'get'
        })
          .then(config => {
            //根据项目类型获取平台特定的配置数据
            let localPlatformConfig = getPlatformConfig(config.platformId)//平台配置数据(本地)
            //使用外部的数据替换本地的数据
            let platformConfig = { ...localPlatformConfig, ...config.platformConfig }
            //构建app配置信息
            let localAppConfig = getAppConfig()
            let appConfig
            if (localAppConfig.isDev) {//开发模式（本地配置优先）
              appConfig = {
                ...config,//服务返回配置的信息
                ...localAppConfig//本地配置的信息
              }
            } else {
              //非开发模式 （服务动态配置优先）
              appConfig = {
                ...localAppConfig,//本地配置的信息
                ...config//服务返回配置的信息
              }
            }
            store.commit('SET_PROJECT_INFO', platformConfig) //保存平台数据
            store.commit('SET_APP_CONFIG', appConfig)
            store.commit('SET_INIT_CONFIG', true)
            resolve(appConfig)
          })
          .catch(reason => {
            console.error('initConfig', reason)
            reject(reason)
          })
      })
    },
    initGlobalCity() {
      //添加城市信息检测流程
      if (!dbManager.GlobalCity) {
        setTimeout(() => store.dispatch('initGlobalCity'), 2000)
      } else {
        store.dispatch('GetGlobalCity')
          .then(list => {
            console.error('=======读取得到数据库成功=====', list)
          }).catch(reason => {
          console.error('=======读取数据库错误=====')
          store.dispatch('SaveGlobalCity')
        })
      }

    },
    GetGlobalCity() {
      return new Promise((resolve, reject) => {
        dbManager.GlobalCity.readAll().then(result => {
          // console.log("GetGlobalCity",result)
          if (result && result.length > 0 && result[0].cityList && result[0].cityList.length > 0) {
            // console.log(result[0].cityList)
            resolve(result[0].cityList)
          } else {
            reject(result)
          }
        }).catch((reason) => {
          reject([])
        })
      })
    },
    SaveGlobalCity() {
      Vue.ls.set(SET_CITY_FLAG, true, 300 * 24 * 60 * 60 * 1000)
      console.log('存储', Vue.ls.get(SET_CITY_FLAG))
      return new Promise((resolve, reject) => {
        axios({
          baseURL: '',
          url: '/GetGlobeCity.json',
          method: 'get'
        }).then(result => {
          // console.log(dbManager)
          let data = { id: 1, cityList: result }
          // console.log(data)
          dbManager.GlobalCity.add(data).catch(err => {
            console.error('dbManager', err)
          })
          resolve(data)
        }).catch((reason) => {
          console.error('SaveGlobalCity', reason)
          reject(reason)
        })
      })
    }

  }
}

export default config
